class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.removeItems(event.target.closest(".cart-item"));
    });
  }
  removeItems(product) {
    const updates = {};
    updates[product.getAttribute("product-id")] = 0;
    document.querySelectorAll(".cart-item").forEach((item) => {
      if (
        item.getAttribute("data-unique-id") ===
        product.getAttribute("data-unique-id")
      ) {
        updates[item.getAttribute("product-id")] = 0;
      }
    });

    document.querySelectorAll(".cart-item").forEach((item) => {
      if (
        item.getAttribute("data-unique-id") ===
        product.getAttribute("data-unique-id")
      ) {
        const overlay = item.querySelector(".loading-overlay");
        if (overlay) overlay.classList.remove("hidden");
      }
    });

    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    })
      .then((response) => response.json())
      .then((cart) => {
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              ?.querySelector(section.selector) ||
            document.getElementById(section.id);
          if (elementToReplace) {
            fetch(`${window.location.pathname}?section_id=${section.section}`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(
                  responseText,
                  "text/html"
                );
                const sourceElement =
                  html.querySelector(section.selector) ||
                  html.getElementById(section.id);
                if (sourceElement) {
                  elementToReplace.innerHTML = sourceElement.innerHTML;
                  const cartDrawer = document.querySelector("cart-drawer");
                  if (cartDrawer) {
                    cartDrawer.classList.toggle(
                      "is-empty",
                      cart.item_count === 0
                    );
                  }
                  if (section.id === "main-cart-footer") {
                    const cartFooter =
                      document.getElementById("main-cart-footer");
                    if (cartFooter) {
                      cartFooter.classList.toggle(
                        "is-empty",
                        cart.item_count === 0
                      );
                    }
                  }
                }
              });
          }
        });

        // Update free shipping progress goals
        this.updateFreeShippingGoals(cart.total_price);

        // Publish cart update event for other components
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-remove-button" });

        // Trigger custom event for cart drawer content update
        document.dispatchEvent(
          new CustomEvent("cart-drawer-content-updated", {
            detail: { source: "cart-remove-button" },
          })
        );

        //  const cartItems = document.querySelector('cart-items');
        //  setTimeout(() => {
        //     if (cartItems) {
        //         cartItems.classList.remove('is-full');
        //         cartItems.classList.add('is-empty');
        //     }
        //  }, 100);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  getSectionsToRender() {
    const mainCartItems = document.getElementById("main-cart-items");
    const mainCartFooter = document.getElementById("main-cart-footer");
    return [
      {
        id: "main-cart-items",
        section: mainCartItems?.dataset?.id || "main-cart-items",
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: mainCartFooter?.dataset?.id || "main-cart-footer",
        selector: ".js-contents",
      },
      // Cart drawer section (use correct section id as in theme)
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
    ];
  }

  updateFreeShippingGoals(cartTotal) {
    // Update all free shipping progress goals on the page
    const freeShippingGoals = document.querySelectorAll(
      "free-progress-shipping-goal"
    );
    freeShippingGoals.forEach((goal) => {
      if (goal.updateShippingGoal) {
        goal.updateShippingGoal(cartTotal);
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    const mainCartItems = document.getElementById("main-cart-items");
    const mainCartFooter = document.getElementById("main-cart-footer");
    const cartDrawerItems = document.getElementById("CartDrawer-CartItems");
    const cartDrawerFooter = document.getElementById("CartDrawer-Footer");

    return [
      {
        id: "main-cart-items",
        section: mainCartItems?.dataset?.id || "main-cart-items",
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: mainCartFooter?.dataset?.id || "main-cart-footer",
        selector: ".js-contents",
      },
      {
        id: "CartDrawer-CartItems",
        section: cartDrawerItems?.dataset?.id || "cart-drawer-items",
        selector: ".js-contents",
      },
      {
        id: "CartDrawer-Footer",
        section: cartDrawerFooter?.dataset?.id || "cart-drawer-footer",
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    this.querySelectorAll(".quantity__button").forEach((button) =>
      button.classList.add("disabled")
    );

    // Check if this is a bundle product
    const currentItem =
      document.getElementById(`CartItem-${line}`) ||
      document.getElementById(`CartDrawer-Item-${line}`);
    const uniqueId = currentItem?.getAttribute("data-unique-id");

    let body;

    if (uniqueId) {
      // Handle bundle products - update all items with the same unique-id
      const updates = {};
      document.querySelectorAll(".cart-item").forEach((item) => {
        if (item.getAttribute("data-unique-id") === uniqueId) {
          updates[item.getAttribute("product-id")] = quantity;
        }
      });

      body = JSON.stringify({
        updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
    } else {
      // Handle regular products - update single line item
      body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
    }

    const url = uniqueId ? routes.cart_update_url : routes.cart_change_url;
    fetch(url, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          // If this is the cart drawer section, trigger a custom event
          if (section.id === "CartDrawer") {
            document.dispatchEvent(
              new CustomEvent("cart-drawer-content-updated", {
                detail: { source: "cart-items" },
              })
            );
          }
        });

        // Update free shipping progress goals
        this.updateFreeShippingGoals(parsedState.total_price);
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });

        // Update free shipping note after cart update
        // Note: Free shipping note is handled by CartFreeShippingNote class
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.querySelectorAll(".quantity__button").forEach((button) =>
          button.classList.remove("disabled")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.querySelectorAll(".quantity__button").forEach((button) =>
          button.classList.remove("disabled")
        );
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    // Check if this is a bundle product
    const currentItem =
      document.getElementById(`CartItem-${line}`) ||
      document.getElementById(`CartDrawer-Item-${line}`);
    const uniqueId = currentItem?.getAttribute("data-unique-id");

    if (uniqueId) {
      // Show loading for all bundle items
      document.querySelectorAll(".cart-item").forEach((item) => {
        if (item.getAttribute("data-unique-id") === uniqueId) {
          const overlay = item.querySelector(".loading-overlay");
          if (overlay) overlay.classList.remove("hidden");
        }
      });
    } else {
      // Show loading for single item
      const cartItemElements = this.querySelectorAll(
        `#CartItem-${line} .loading-overlay`
      );
      const cartDrawerItemElements = this.querySelectorAll(
        `#CartDrawer-Item-${line} .loading-overlay`
      );

      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
        overlay.classList.remove("hidden")
      );
    }

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    // Check if this is a bundle product
    const currentItem =
      document.getElementById(`CartItem-${line}`) ||
      document.getElementById(`CartDrawer-Item-${line}`);
    const uniqueId = currentItem?.getAttribute("data-unique-id");

    if (uniqueId) {
      // Hide loading for all bundle items
      document.querySelectorAll(".cart-item").forEach((item) => {
        if (item.getAttribute("data-unique-id") === uniqueId) {
          const overlay = item.querySelector(".loading-overlay");
          if (overlay) overlay.classList.add("hidden");
        }
      });
    } else {
      // Hide loading for single item
      const cartItemElements = this.querySelectorAll(
        `#CartItem-${line} .loading-overlay`
      );
      const cartDrawerItemElements = this.querySelectorAll(
        `#CartDrawer-Item-${line} .loading-overlay`
      );

      cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
      cartDrawerItemElements.forEach((overlay) =>
        overlay.classList.add("hidden")
      );
    }
  }

  // Free shipping note visibility is handled by CartFreeShippingNote class

  updateFreeShippingGoals(cartTotal) {
    // Update all free shipping progress goals on the page
    const freeShippingGoals = document.querySelectorAll(
      "free-progress-shipping-goal"
    );
    freeShippingGoals.forEach((goal) => {
      if (goal.updateShippingGoal) {
        goal.updateShippingGoal(cartTotal);
      }
    });
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Free Progress Shipping Goal Component
class FreeProgressShippingGoal extends HTMLElement {
  constructor() {
    super();
    this.progress = this.querySelector("progress-bar");
    this.goal = parseFloat(this.dataset.minimumAmount) / 100;
    this.cartTotal = parseFloat(this.dataset.cartTotal) / 100;
    this.money_format = window.Shopify?.money_format || "{{amount}}";

    this.selectors = {
      leftToSpend: "[data-left-to-spend]",
    };

    console.log("Component initialized with:", {
      goal: this.goal,
      cartTotal: this.cartTotal,
      minimumAmount: this.dataset.minimumAmount,
      cartTotalRaw: this.dataset.cartTotal,
    });

    // Check if async/await is supported
    if (typeof Promise !== "undefined" && Promise.prototype.finally) {
      // Initialize the component with async functionality
      this.initializeComponent();
    } else {
      // Fallback for older browsers
      console.warn("Async/await not supported, using fallback initialization");
      this.updateShippingGoal(this.cartTotal * 100);
    }
  }

  async initializeComponent() {
    // Start with immediate fallback for instant display
    this.updateShippingGoal(this.cartTotal * 100);

    // Then try to get fresh data in background (non-blocking)
    this.refreshCartTotalInBackground();
  }

  async refreshCartTotalInBackground() {
    try {
      // Quick check for cart data without long waits
      if (
        window.Shopify &&
        window.Shopify.cart &&
        window.Shopify.cart.total_price
      ) {
        this.updateShippingGoal(window.Shopify.cart.total_price);
        return;
      }

      // Quick check for DOM elements without waiting
      const totalElement =
        document.querySelector(".totals__subtotal-value") ||
        document.querySelector(".cart-drawer__footer .totals__subtotal-value");
      if (totalElement) {
        const totalText = totalElement.textContent;
        const match = totalText.match(/[\d,]+\.?\d*/);
        if (match) {
          const currentTotal = parseFloat(match[0].replace(",", "")) * 100;
          this.updateShippingGoal(currentTotal);
          return;
        }
      }

      // Only wait if we really need to
      await this.waitForCartDataQuick();
      await this.refreshCartTotal();
    } catch (error) {
      // Silently fail in background - we already have fallback data
      console.debug("Background cart refresh failed:", error);
    }
  }

  async waitForCartDataQuick() {
    // Quick wait for Shopify cart object (much shorter timeout)
    if (!window.Shopify || !window.Shopify.cart) {
      await new Promise((resolve, reject) => {
        let attempts = 0;
        const maxAttempts = 10; // 1 second max wait (10 * 100ms)

        const checkCart = () => {
          attempts++;
          if (window.Shopify && window.Shopify.cart) {
            resolve();
          } else if (attempts >= maxAttempts) {
            reject(new Error("Cart data not available after quick timeout"));
          } else {
            setTimeout(checkCart, 100);
          }
        };
        checkCart();
      });
    }
  }

  async waitForCartData() {
    // Wait for Shopify cart object to be available
    if (!window.Shopify || !window.Shopify.cart) {
      await new Promise((resolve, reject) => {
        let attempts = 0;
        const maxAttempts = 50; // 5 seconds max wait (50 * 100ms)

        const checkCart = () => {
          attempts++;
          if (window.Shopify && window.Shopify.cart) {
            resolve();
          } else if (attempts >= maxAttempts) {
            reject(new Error("Cart data not available after timeout"));
          } else {
            setTimeout(checkCart, 100);
          }
        };
        checkCart();
      });
    }
  }

  async waitForCartDrawerQuick() {
    // Quick wait for cart drawer (much shorter timeout)
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && !cartDrawer.querySelector(".totals__subtotal-value")) {
      await new Promise((resolve, reject) => {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === "childList" &&
              cartDrawer.querySelector(".totals__subtotal-value")
            ) {
              observer.disconnect();
              resolve();
            }
          });
        });

        observer.observe(cartDrawer, { childList: true, subtree: true });

        // Much shorter timeout - 500ms
        const timeout = setTimeout(() => {
          observer.disconnect();
          reject(new Error("Cart drawer not rendered after quick timeout"));
        }, 500);

        // Clean up timeout if resolved
        const originalResolve = resolve;
        resolve = () => {
          clearTimeout(timeout);
          originalResolve();
        };
      });
    }
  }

  async waitForCartDrawer() {
    // Wait for cart drawer to be rendered if we're in a cart drawer context
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && !cartDrawer.querySelector(".totals__subtotal-value")) {
      await new Promise((resolve, reject) => {
        let attempts = 0;
        const maxAttempts = 30; // 3 seconds max wait

        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === "childList" &&
              cartDrawer.querySelector(".totals__subtotal-value")
            ) {
              observer.disconnect();
              resolve();
            }
          });
        });

        observer.observe(cartDrawer, { childList: true, subtree: true });

        // Fallback timeout
        const timeout = setTimeout(() => {
          observer.disconnect();
          reject(new Error("Cart drawer not rendered after timeout"));
        }, 3000);

        // Clean up timeout if resolved
        const originalResolve = resolve;
        resolve = () => {
          clearTimeout(timeout);
          originalResolve();
        };
      });
    }
  }

  updateShippingGoal(amount) {
    // Immediate visibility update
    if (amount > 0) {
      this.classList.remove("hidden");
    } else {
      this.classList.add("hidden");
    }

    this.cartTotal = amount / 100;
    this.goalLeft = this.goal - this.cartTotal;
    this.goalDone = this.goalLeft <= 0;

    // Only complete free shipping when goal is reached, not for bundles or subscriptions
    if (this.goalDone) {
      this.percent = 100;
      this.goalDone = true;
      console.log(
        `Free shipping goal completed (goalDone: ${this.goalDone}) - setting progress to 100%`
      );
      // Trigger free shipping note update
      this.triggerFreeShippingNoteUpdate();
    } else {
      this.percent = (this.cartTotal * 100) / this.goal;
      if (this.percent >= 100) this.percent = 100;
    }

    // Immediate progress bar update
    if (this.progress) {
      this.progress.style.setProperty("--percent", `${this.percent}%`);
      this.progress.dataset.value = this.cartTotal;
      this.progress.dataset.max = this.goal;
    }

    // Immediate message update - only show success when goal is reached
    if (this.cartTotal >= this.goal) {
      this.classList.add("free-shipping-goal--done");
      this.showDeliveryNote();
    } else {
      let spend = (this.goal - this.cartTotal) * 100;
      const leftToSpendElement = this.querySelector(this.selectors.leftToSpend);
      if (leftToSpendElement) {
        // Try to use Shopify's money format if available, otherwise use simple formatting
        let formattedAmount;
        if (window.Shopify && window.Shopify.formatMoney) {
          formattedAmount = window.Shopify.formatMoney(
            spend,
            this.money_format
          );
        } else {
          // Simple fallback formatting
          formattedAmount = `£${(spend / 100).toFixed(2)}`;
        }
        leftToSpendElement.innerHTML = formattedAmount;
      }
      this.classList.remove("free-shipping-goal--done");
      this.hideDeliveryNote();
    }
  }

  showDeliveryNote() {
    const successLabel = this.querySelector(
      ".free-shipping-goal__label--success"
    );
    const defaultLabel = this.querySelector(
      ".free-shipping-goal__label--default"
    );

    if (successLabel) successLabel.style.display = "flex";
    if (defaultLabel) defaultLabel.style.display = "none";
  }

  hideDeliveryNote() {
    const successLabel = this.querySelector(
      ".free-shipping-goal__label--success"
    );
    const defaultLabel = this.querySelector(
      ".free-shipping-goal__label--default"
    );

    if (successLabel) successLabel.style.display = "none";
    if (defaultLabel) defaultLabel.style.display = "flex";
  }

  // Check if cart has bundle products
  hasBundleInCart() {
    const cartItems = document.querySelectorAll(".cart-item");
    for (let item of cartItems) {
      // Check if item has data-unique-id property (indicates bundle)
      if (item.hasAttribute("data-unique-id")) {
        return true;
      }
    }
    return false;
  }

  // Check if cart has subscription starter set (bundle with selling plan)
  hasSubscriptionStarterSetInCart() {
    const cartItems = document.querySelectorAll(".cart-item");
    for (let item of cartItems) {
      if (item.hasAttribute("data-unique-id")) {
        const subscriptionText = item.querySelector(
          ".product-option[style*='color:#21542e'], .product-option[style*='#21542e']"
        );
        if (subscriptionText) {
          return true;
        }
        // Also check for subscription-related text content as fallback
        const itemText = item.textContent.toLowerCase();
        if (
          itemText.includes("every") &&
          (itemText.includes("month") || itemText.includes("week"))
        ) {
          // Likely a subscription item
          return true;
        }
      }
    }
    return false;
  }

  // Trigger free shipping note update
  triggerFreeShippingNoteUpdate() {
    // Dispatch a custom event to trigger free shipping note update
    document.dispatchEvent(
      new CustomEvent("free-shipping-goal-updated", {
        detail: {
          goalDone: this.goalDone,
          percent: this.percent,
        },
      })
    );
  }

  // Method to refresh cart total from current cart state
  async refreshCartTotal() {
    try {
      // Wait for cart data and drawer to be ready
      await this.waitForCartData();
      await this.waitForCartDrawer();

      // Try to get the current cart total from various sources
      let currentTotal = 0;

      // Check if we can get it from Shopify cart object
      if (
        window.Shopify &&
        window.Shopify.cart &&
        window.Shopify.cart.total_price
      ) {
        currentTotal = window.Shopify.cart.total_price;
      }
      // Check if we can get it from cart drawer subtotal
      else if (document.querySelector(".totals__subtotal-value")) {
        const totalElement = document.querySelector(".totals__subtotal-value");
        const totalText = totalElement.textContent;
        // Extract number from currency string (e.g., "£25.00" -> 2500)
        const match = totalText.match(/[\d,]+\.?\d*/);
        if (match) {
          currentTotal = parseFloat(match[0].replace(",", "")) * 100;
        }
      }
      // Check if we can get it from cart total in the drawer
      else if (
        document.querySelector(".cart-drawer__footer .totals__subtotal-value")
      ) {
        const totalElement = document.querySelector(
          ".cart-drawer__footer .totals__subtotal-value"
        );
        const totalText = totalElement.textContent;
        const match = totalText.match(/[\d,]+\.?\d*/);
        if (match) {
          currentTotal = parseFloat(match[0].replace(",", "")) * 100;
        }
      }
      // Fallback to the data attribute
      else {
        currentTotal = this.cartTotal * 100;
      }

      console.log(
        "Refreshing cart total:",
        currentTotal,
        "from various sources"
      );
      this.updateShippingGoal(currentTotal);
    } catch (error) {
      console.warn("Cart total refresh failed, using fallback:", error);
      // Fallback to original data
      this.updateShippingGoal(this.cartTotal * 100);
    }
  }

  // Fast refresh method for immediate updates
  refreshCartTotalFast() {
    // Try to get the current cart total from various sources without waiting
    let currentTotal = 0;

    // Check if we can get it from Shopify cart object
    if (
      window.Shopify &&
      window.Shopify.cart &&
      window.Shopify.cart.total_price
    ) {
      currentTotal = window.Shopify.cart.total_price;
    }
    // Check if we can get it from cart drawer subtotal
    else if (document.querySelector(".totals__subtotal-value")) {
      const totalElement = document.querySelector(".totals__subtotal-value");
      const totalText = totalElement.textContent;
      const match = totalText.match(/[\d,]+\.?\d*/);
      if (match) {
        currentTotal = parseFloat(match[0].replace(",", "")) * 100;
      }
    }
    // Check if we can get it from cart total in the drawer
    else if (
      document.querySelector(".cart-drawer__footer .totals__subtotal-value")
    ) {
      const totalElement = document.querySelector(
        ".cart-drawer__footer .totals__subtotal-value"
      );
      const totalText = totalElement.textContent;
      const match = totalText.match(/[\d,]+\.?\d*/);
      if (match) {
        currentTotal = parseFloat(match[0].replace(",", "")) * 100;
      }
    }
    // Fallback to the data attribute
    else {
      currentTotal = this.cartTotal * 100;
    }

    this.updateShippingGoal(currentTotal);
  }

  connectedCallback() {
    // Use fast refresh for immediate response
    this.refreshCartTotalFast();

    // Listen for cart updates to refresh progress
    document.addEventListener("cart-drawer-content-updated", () => {
      this.refreshCartTotalFast();
    });
  }

  // Non-async fallback method for compatibility
  refreshCartTotalSync() {
    // Synchronous version that doesn't use async/await
    let currentTotal = 0;

    // Check if we can get it from Shopify cart object
    if (
      window.Shopify &&
      window.Shopify.cart &&
      window.Shopify.cart.total_price
    ) {
      currentTotal = window.Shopify.cart.total_price;
    }
    // Check if we can get it from cart drawer subtotal
    else if (document.querySelector(".totals__subtotal-value")) {
      const totalElement = document.querySelector(".totals__subtotal-value");
      const totalText = totalElement.textContent;
      const match = totalText.match(/[\d,]+\.?\d*/);
      if (match) {
        currentTotal = parseFloat(match[0].replace(",", "")) * 100;
      }
    }
    // Fallback to the data attribute
    else {
      currentTotal = this.cartTotal * 100;
    }

    this.updateShippingGoal(currentTotal);
  }
}

// Register the custom element
customElements.define("free-progress-shipping-goal", FreeProgressShippingGoal);

// Progress Bar Component
class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.style.setProperty("--percent", "0%");
  }

  connectedCallback() {
    // Initialize with 0% progress
    this.style.setProperty("--percent", "0%");
  }
}

// Register the progress bar component
customElements.define("progress-bar", ProgressBar);

// Global function to update free shipping goals (can be called from other components)
window.updateFreeShippingGoals = function (cartTotal) {
  const freeShippingGoals = document.querySelectorAll(
    "free-progress-shipping-goal"
  );
  freeShippingGoals.forEach((goal) => {
    if (goal.updateShippingGoal) {
      goal.updateShippingGoal(cartTotal);
    }
  });
};

// Listen for cart updates from Shopify
document.addEventListener("shopify:cart:updated", function (event) {
  if (event.detail && event.detail.cart) {
    window.updateFreeShippingGoals(event.detail.cart.total_price);
  }
});

// Listen for cart changes from other sources
document.addEventListener("cart:updated", function (event) {
  if (event.detail && event.detail.cart) {
    window.updateFreeShippingGoals(event.detail.cart.total_price);
  }
});

// Listen for cart drawer opening to refresh free shipping goals
document.addEventListener("cart-drawer:opened", function () {
  // Use fast refresh for immediate response
  const freeShippingGoals = document.querySelectorAll(
    "free-progress-shipping-goal"
  );

  freeShippingGoals.forEach((goal) => {
    if (goal.refreshCartTotalFast) {
      goal.refreshCartTotalFast();
    }
  });
});

// Free shipping note functionality
class CartFreeShippingNote {
  constructor() {
    this.instanceId = Math.random().toString(36).substr(2, 9);
    console.log(`CartFreeShippingNote instance created: ${this.instanceId}`);
    this.init().catch(console.error);
  }

  async init() {
    // Initial check
    await this.updateFreeShippingNote();

    // Listen for cart updates
    document.addEventListener("cart-update", async () => {
      await this.updateFreeShippingNote();
    });
    document.addEventListener("cart:refresh", async () => {
      await this.updateFreeShippingNote();
    });
    document.addEventListener("cart-drawer-content-updated", async () => {
      await this.updateFreeShippingNote();
    });
    document.addEventListener("free-shipping-goal-updated", async () => {
      await this.updateFreeShippingNote();
    });

    // Monitor for changes in free shipping goal status
    await this.setupObserver();
  }

  // Function to check if cart has bundle products (items with _unique_id property)
  hasBundleInCart() {
    const cartItems = document.querySelectorAll(".cart-item");
    for (let item of cartItems) {
      // Check if item has _unique_id property (indicates bundle)
      if (item.hasAttribute("data-unique-id")) {
        return true;
      }
    }
    return false;
  }

  hasSubscriptionStarterSetInCart() {
    const cartItems = document.querySelectorAll(".cart-item");
    for (let item of cartItems) {
      if (item.hasAttribute("data-unique-id")) {
        const subscriptionText = item.querySelector(
          ".product-option[style*='color:#21542e'], .product-option[style*='#21542e']"
        );
        if (subscriptionText) {
          return true;
        }
        const itemText = item.textContent.toLowerCase();
        if (
          itemText.includes("every") &&
          (itemText.includes("month") || itemText.includes("week"))
        ) {
          return true;
        }
      }
    }
    return false;
  }

  async checkCartTotal() {
    // Wait for DOM to be ready
    await this.waitForElement(".totals__subtotal-value");

    // Try multiple selectors for cart total
    const subtotalElement =
      document.querySelector(".totals__subtotal-value") ||
      document.querySelector("[data-cart-total]") ||
      document.querySelector(".cart-drawer__subtotal .totals__subtotal-value");

    if (subtotalElement) {
      const totalText = subtotalElement.textContent.trim();
      console.log("Cart total text:", totalText);

      // Extract number from currency string (e.g., "£35.00" -> 35.00)
      const match = totalText.match(/[\d,]+\.?\d*/);
      if (match) {
        const total = parseFloat(match[0].replace(",", ""));
        console.log("Parsed total:", total);
        return total > 20; // £35 threshold (not £350)
      }
    }

    // Fallback: try to get total from data attribute
    const cartTotalElement = document.querySelector("[data-cart-total]");
    if (cartTotalElement) {
      const total =
        parseFloat(cartTotalElement.getAttribute("data-cart-total")) / 100;
      console.log("Cart total from data attribute:", total);
      return total > 20;
    }

    console.log("Could not find cart total element");
    return false;
  }

  // Wait for element to be available in DOM
  async waitForElement(selector, timeout = 1000) {
    const startTime = Date.now();

    while (Date.now() - startTime < timeout) {
      const element = document.querySelector(selector);
      if (element) {
        return element;
      }
      await new Promise((resolve) => requestAnimationFrame(resolve));
    }

    return null;
  }

  // Function to update free shipping note visibility
  async updateFreeShippingNote() {
    console.log(
      `updateFreeShippingNote called by instance: ${this.instanceId}`
    );
    const freeShippingNote = document.querySelector(
      "[data-free-shipping-note]"
    );
    const freeShippingGoal = document.querySelector(
      "free-progress-shipping-goal"
    );

    if (!freeShippingNote) {
      console.log("Free shipping note element not found");
      return;
    }

    try {
      const traceRes = await fetch("https://1.1.1.1/cdn-cgi/trace");
      const traceText = await traceRes.text();
      const match = traceText.match(/loc=([A-Z]+)/);
      const countryCode = match ? match[1] : null;

      console.log("Fetched country:", countryCode);

      if (countryCode !== "GB") {
        console.log(
          `Instance ${this.instanceId}: Country is not GB (${countryCode}), hiding note`
        );
        freeShippingNote.style.display = "none";
        return;
      }

      console.log(
        `Instance ${this.instanceId}: Country is GB, proceeding with checks`
      );

      // Check if data-bundles attribute is true
      const dataBundles = freeShippingNote.getAttribute("data-bundles");
      const isBundleTrue = dataBundles === "true";

      // TEMPORARY: If data-bundles is true, always show (for testing)
      if (isBundleTrue) {
        console.log(
          `Instance ${this.instanceId}: data-bundles is true, forcing display to BLOCK`
        );
        freeShippingNote.style.display = "block";
        return;
      }

      const isGoalMet = freeShippingGoal
        ? freeShippingGoal.classList.contains("free-shipping-goal--done")
        : false;

      const hasSubscriptionStarterSet = this.hasSubscriptionStarterSetInCart();
      const cartTotalExceeds = await this.checkCartTotal();

      console.log("Free shipping check:", {
        isGoalMet,
        hasSubscriptionStarterSet,
        cartTotalExceeds,
        isBundleTrue,
        dataBundles,
        countryCode,
        shouldShow:
          isGoalMet ||
          hasSubscriptionStarterSet ||
          cartTotalExceeds ||
          isBundleTrue,
      });

      console.log("Individual condition results:", {
        isGoalMet: isGoalMet,
        hasSubscriptionStarterSet: hasSubscriptionStarterSet,
        cartTotalExceeds: cartTotalExceeds,
        isBundleTrue: isBundleTrue,
        "dataBundles value": dataBundles,
        "dataBundles === 'true'": dataBundles === "true",
      });

      if (
        isGoalMet ||
        hasSubscriptionStarterSet ||
        cartTotalExceeds ||
        isBundleTrue
      ) {
        freeShippingNote.style.display = "block";
        console.log(`Instance ${this.instanceId}: Setting display to BLOCK`);
      } else {
        freeShippingNote.style.display = "none";
        console.log(`Instance ${this.instanceId}: Setting display to NONE`);
      }
    } catch (error) {
      console.error("Error checking country for free shipping:", error);
      freeShippingNote.style.display = "none";
    }
  }

  async setupObserver() {
    const observer = new MutationObserver(async (mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          await this.updateFreeShippingNote();
        }
      }
    });

    await this.waitForElement("free-progress-shipping-goal");
    const freeShippingGoal = document.querySelector(
      "free-progress-shipping-goal"
    );
    if (freeShippingGoal) {
      observer.observe(freeShippingGoal, { attributes: true });
    }
  }
}

// Initialize free shipping note functionality (only once)
let freeShippingNoteInstance = null;

function initializeFreeShippingNote() {
  if (!freeShippingNoteInstance) {
    freeShippingNoteInstance = new CartFreeShippingNote();
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeFreeShippingNote);
} else {
  initializeFreeShippingNote();
}
